import { FreeExtrachargeDTO } from '@app/src/views/StepOne/form/dtos/FreeExtrachargeDTO';
import { FreeExtrachargeModel } from '@app/src/views/StepOne/form/models/freeExtracharge';

export const hydrateData = (data: FreeExtrachargeDTO[]) => data.map((data: FreeExtrachargeDTO) =>
  ({
    name: data.name,
    priceIgv: data.price_igv,
    alias: data.alias,
    price: data.price,
    tariffId: data.tariff_id,
    tariffCode: data.tariff_code,
    publicationId: data.publication_id,
    id: data.id
  })
) as FreeExtrachargeModel[]
